import { render } from "./TransactionDetailIndex.vue?vue&type=template&id=132285a2"
import script from "./TransactionDetailIndex.vue?vue&type=script&lang=js"
export * from "./TransactionDetailIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__